// src/pages/LoanBalanceLedger/LoanBalanceLedgerThunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import { getLoanLedgerApi } from "../../../apiservice/reports";
import { getAccountBySeachApi } from "../../../apiservice/setting";

export const fetchLoanBalanceLedger = createAsyncThunk(
  "loanBalanceLedger/fetch",
  async ({ filters }, { rejectWithValue }) => {
    try {
      const payload = {
        accId: filters?.accId || null,
        dateFrom: filters?.fromDate || null,
        dateTo: filters?.toDate || null,
      };
      const res = await getLoanLedgerApi(payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchLoanAccountsBySearch = createAsyncThunk(
  "loanBalanceLedger/fetchAccountsBySearch",
  async (search, { rejectWithValue }) => {
    try {
      const res = await getAccountBySeachApi({
        query: search.trim(),
        multiType: ["loan"],
      });
      return (res.data || []).map((c) => ({
        sale_id: c.acc_id,
        display_text: c.acc_name,
      }));
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
